import { ReactNode, useState } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import { InputLabel } from './InputLabel';
import './DateInput.css';

export const DateInput = ({
  label,
  value,
  onChange,
}: {
  label?: ReactNode;
  value: string | Date;
  onChange: (val: string) => void;
}) => {
  const [open, setOpen] = useState(false);
  const date = value instanceof Date ? value : new Date(value);

  return (
    <div>
      <InputLabel label={label} />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          value={isValid(date) ? date : null}
          onChange={(next, context) => {
            if (next && isValid(next) && !context.validationError)
              onChange(format(next, 'yyyy-MM-dd'));
          }}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          className="datetimeinput"
          slotProps={{
            popper: { disablePortal: true },
            dialog: { disablePortal: true },
            textField: {
              fullWidth: true,
              inputProps: {
                readOnly: true,
                onClick: () => setOpen(true),
                'aria-label': typeof label === 'string' ? label : 'Date',
              },
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};
